/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { ENDPOINTS, parseApiError, restClient } from '../../../../../../../interface/api';
import { CONTAINER_STRINGS as STRINGS } from './containerQuarantine.strings';
import type { ContainerPage, ContainerQuery } from './containerQuarantine.types';

/** The backend answers 404 while IQ cannot list one instance's containers (NEXUS-55749 item 5). */
export class ContainersNotAvailableError extends Error {
  constructor() {
    super(STRINGS.errors.notAvailable);
    this.name = 'ContainersNotAvailableError';
  }
}

export function buildContainerParams(query: ContainerQuery): URLSearchParams {
  const params = new URLSearchParams();
  params.set('sortBy', query.sortBy);
  params.set('asc', String(query.asc));
  params.set('page', String(query.page));
  params.set('pageSize', String(query.pageSize));
  return params;
}

/** GET that turns a 404 into `notFound()` and any other failure into the server's message, or `fallback`. */
export async function getJson<T>(url: string, fallback: string, notFound: () => Error): Promise<T> {
  try {
    return await restClient.get<T>(url);
  } catch (error) {
    const parsed = parseApiError(error);
    if (parsed.status === 404) {
      throw notFound();
    }
    throw new Error(parsed.message || fallback);
  }
}

export function fetchContainers(query: ContainerQuery): Promise<ContainerPage> {
  return getJson<ContainerPage>(
    `${ENDPOINTS.FIREWALL_CONTAINER_QUARANTINE}?${buildContainerParams(query).toString()}`,
    STRINGS.errors.loadList,
    () => new ContainersNotAvailableError()
  );
}
